/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Tooltip, Grid } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import { AudaTarget } from './AudaTarget';
import { SelectedPartsMapping } from './Mapping/SelectedPartsMapping';
import CustomAudaTargetSettingsForm from './CustomAudaTarget.settingsForm';
import getLocalParams from '../localizationCustoms';
import FormioErrorHandler from '../../../components/FormioErrorHandler/FormioErrorPopup';

const CustomAudaTarget = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.setAudaTargetValue = this.setAudaTargetValue.bind(this);
  }

  componentDidMount() {
    const { value } = this.state || null;
    if (value) {
      const gwElement = document.getElementsByName('AudaTargetVehDamage_EcoPopup-DamageText')[0];
      if (gwElement) {
        gwElement.value = JSON.stringify(value?.value);
        gwElement.dispatchEvent(new Event('change'));
      } else {
        this.setAudaTargetValue();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.state || null;
    if (value?.value !== prevState?.value?.value
    ) {
      const gwElement = document.getElementsByName('AudaTargetVehDamage_EcoPopup-DamageText')[0];
      if (gwElement) {
        gwElement.value = JSON.stringify(value?.value);
        gwElement.dispatchEvent(new Event('change'));
      } else {
        this.setAudaTargetValue();
      }
    }
  }

  setAudaTargetValue = () => {
    const { state: { value }, props: { component: { useReviewLabel, label, reviewLabel }, onChange } } = this || null;
    const newLabel = useReviewLabel ? reviewLabel : label;
    const gwElement = document.getElementsByName('AudaTargetVehDamage_EcoPopup-DamageText')[0];
    let parsedGWElementValue = null;
    if (gwElement) {
      parsedGWElementValue = { value: JSON.parse(gwElement.value), review: { label: newLabel, value: this.getReviewValue(JSON.parse(gwElement.value)?.parts) } };
    } else {
      parsedGWElementValue = value;
    }

    onChange(parsedGWElementValue);
  };

  getReviewValue = (parts) => {
    const reviewValue = [];
    // eslint-disable-next-line no-unused-expressions
    parts && parts.forEach((part) => {
      reviewValue.push(`${SelectedPartsMapping(part.id)} (${part.severity.toLowerCase()})`);
    });
    return reviewValue;
  };

  render() {
    const { value } = this.state || null;
    const { component, formData, localParams, intl } = this.props || null;
    const { hideCustomLabel, label, tooltip } = component || null;
    const vehicleBody = formData?.claim_type?.vehicle?.body;

    return (
      <Grid>
        {!hideCustomLabel && (
        <>
          <Grid.Row>
            <Grid.Column colSm12>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <label className="label-question">
                  <FormattedMessage id={label} defaultMessage={label} />
                </label>
                {tooltip !== '' && (
                <Tooltip id="audatarget_tooltip" primary>
                  <FormattedMessage id={tooltip} defaultMessage={tooltip} />
                </Tooltip>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column colSm12>
              <p style={{ fontSize: '15px' }}><FormattedMessage id="Please select a vehicle panel and then choose the severity." defaultMessage="Please select a vehicle panel and then choose the severity." /></p>
            </Grid.Column>
          </Grid.Row>
        </>
        )}
        <Grid.Row>
          <Grid.Column colSm12>
            <AudaTarget intl={intl} localParams={localParams} key={`audatarget_${value?.value}`} vehicleBody={vehicleBody} setAudaTargetValue={this.setAudaTargetValue} />
            <input type="text" name="AudaTargetVehDamage_EcoPopup-DamageText" defaultValue="{&quot;parts&quot;:[]}" maxLength={1333} style={{ display: 'none' }} autoCapitalize="none" autoComplete="GW_OFF" />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
};

const CustomAudaTargetWithIntl = injectIntl(CustomAudaTarget);

export default class AudaTargetComp extends ReactComponent {
  /**
       * This function tells the form builder about your component. It's name, icon and what group it should be in.
       *
       * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
       */
  static get builderInfo() {
    return {
      title: 'Custom AudaTarget',
      icon: 'file',
      group: 'premium',
      weight: 80,
      documentation: '/userguide/#file',
      schema: AudaTargetComp.schema(),
    };
  }

  /**
       * This function is the default settings for the component. At a minimum you want to set the type to the registered
       * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
       *
       * @param sources
       * @returns {*}
       */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customaudatarget',
      },
      extend,
    );
  }

  /*
       * Defines the settingsForm when editing a component in the builder.
       */
  static editForm = CustomAudaTargetSettingsForm;

  /**
       * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
       *
       * @param DOMElement
       * #returns ReactInstance
       */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <FormioErrorHandler>
          <CustomAudaTargetWithIntl
            inputRef={(refer) => {
              instance = refer;
            }}
            localParams={localParams}
            component={this.component} // These are the component settings if you want to use them to render the component.
            value={this.dataValue || this.dataForSetting} // The starting value of the component.
            formData={this.root?.parent?._data}
            onChange={this.updateValue}
          />
        </FormioErrorHandler>
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  /**
       * Automatically detach any react components.
       *
       * @param element
       */
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
